export enum browserVersions {
    CHROME = 76,
    FIREFOX = 69,
    SAFARI = 12,
    EDGECHROMIUM = 80
}